<template>
  <ul>
    <li
      v-for="(link, index) in links"
      :key="`homelink-${index}`"
      class="py-1"
      :class="[linkClasses]"
    >
      <router-link :to="link.to" v-if="link.to">
        {{ link.title }}
      </router-link>
      <button
        v-else-if="link.openModal === 'login'"
        @click="openLoginSelectionModal(true)"
      >
        {{ link.title }}
      </button>
      <button
        v-else-if="link.openModal === 'register'"
        @click="openSignupSelectionModal(true)"
      >
        {{ link.title }}
      </button>
      <a v-else :href="link.href">
        {{ link.title }}
      </a>
    </li>
  </ul>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'LinksList',
  props: {
    links: {
      type: Array,
      required: true
    },
    linkClasses: {
      type: String,
      default: ''
    }
  },
  methods: {
    ...mapActions([ 'openAuthModal', 'setAuthTabModal', 'openLoginSelectionModal', 'openSignupSelectionModal' ])
  }
}
</script>
